import { VideoHTMLAttributes } from 'react';
import { classes } from '../../../../lib/utils/cssUtils';
import styles from './Video.module.scss';
import { VideoJsProps } from './VideoDetails.types';

const PLAYER_CONFIG: VideoHTMLAttributes<HTMLVideoElement> & {
  class?: string;
  [key: `data-${string}`]: string | boolean;
  'vjs-fluid': boolean;
} = {
  width: 1280,
  height: 720,
  class: classes('video-js', styles.video),
  'data-embed': 'default',
  'data-application-id': true,
  muted: true,
  controls: true,
  'vjs-fluid': true,
};

const VideoJs = ({ accountId, playerId, videoId, componentId }: VideoJsProps) => {
  return (
    <video-js
      {...PLAYER_CONFIG}
      id={componentId}
      data-account={accountId}
      data-player={playerId}
      data-video-id={videoId}
    />
  );
};

export default VideoJs;
